import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReporting = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0 0) scale(1.1429)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M9.99985 1.05493C8.31534 1.24319 6.71821 1.90325 5.39229 2.95917C4.06637 4.01508 3.06554 5.42393 2.50499 7.02355C1.94444 8.62318 1.84696 10.3486 2.22376 12.0012C2.60056 13.6538 3.43632 15.1664 4.63487 16.3649C5.83341 17.5635 7.34603 18.3992 8.99861 18.776C10.6512 19.1528 12.3766 19.0553 13.9762 18.4948C15.5759 17.9342 16.9847 16.9334 18.0406 15.6075C19.0965 14.2816 19.7566 12.6844 19.9448 10.9999H9.99985V1.05493Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M20 7H14V2C15.3834 2.40901 16.6399 3.07009 17.6779 3.93508C18.7159 4.80006 19.5092 5.84714 20 7V7Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	})]
});
const ForwardRef = forwardRef(SvgReporting);
export default ForwardRef;
